<div class="ledger-container pb-20" *ngIf="auditTrailArr != undefined">

  <!-- Top Header -->
  <div class="row tab-nav pl-0 pr-0">

    <!-- Breadcrumb -->
    <div class="col-sm-4">
      <ul class="page-nav d-flex align-item-center list-inline list-unstyled p-0 m-0">
        <li [routerLink]="['/']" class="text-grey text-capitalize cursor hover-text-primary transition">
          Reports
        </li>

        <li>
          <img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-left.svg" alt="">
        </li>

        <li class="text-grey text-capitalize cursor text-primary transition">
          Audit Trail
        </li>
      </ul>
    </div>

    <!-- Date Range -->
    <div class="col-sm-4 text-center">
      <span class="rec-date d-block text-center">
        <div class="noWrap justify-content-around">
          <div class="cname text-bold">

            <span class="text-bold" *ngIf="duration?.from">From</span>

            <h5 style="margin-right: 5px;" class="mb-0 d-inline">

              <span class="date text-bold text-orange" *ngIf="duration?.from">
                {{ duration?.from }}
              </span>

              <span class="date text-bold" *ngIf="duration?.from">
                To
              </span>

              <span class="date text-bold text-orange">
                {{ duration?.to }}
              </span>

            </h5>

            <button title="Custom Search" class="btn save-as text-bold bg-whiteSmoke" type="button"
              (click)="openAdvanceSearchModal()">

              <img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/green-edit.svg" alt="" width="15px">
            </button>

          </div>
        </div>
      </span>
    </div>

    <!-- Search + Export -->
    <div class="col-sm-4 d-flex align-item-center justify-content-end">

      <div class="page-search-box input-group d-flex align-item-center mr-2"
        style="height: fit-content; text-align: left;">

        <input type="text" class="form-control" [(ngModel)]="onSearch" (ngModelChange)="onSearchFilter($event)"
          placeholder="Search" style="text-align:left" />
      </div>

      <button class="btn-style bg-green" (click)="downloadExcel()">
        Excel
      </button>

    </div>
  </div>

  <!-- Table -->
  <div #scrollContainer class="table-container" (scroll)="onTableScroll($event)">
    <div class="table">

      <nz-table #auditData [nzData]="auditTrailArr" [nzFrontPagination]="false">

        <thead>
          <tr>
            <th class="text-left" style="min-width:170px;">Date & Time</th>
            <th class="text-left" style="min-width:150px;">Transaction No</th>
            <th class="text-left" style="min-width:160px;">Transaction Type</th>
            <th class="text-left" style="min-width:160px;">User</th>
            <th class="text-left" style="min-width:350px;">Description</th>
          </tr>
        </thead>

        <ng-container>

          <tbody class="scroll-body main-panel" [ngStyle]="{height: innerHeight}">

            <tr *ngFor="let row of auditTrailArr">

              <td class="text-left text-grey">
                {{ row.invoice_date | date:'dd/MM/yyyy hh:mm a' }}
              </td>

              <td class="text-left text-grey">
                {{ row.transaction_no }}
              </td>

              <td class="text-left text-grey">
                {{ row.transaction_type }}
              </td>

              <td class="text-left text-grey">
                {{ row.user_name }}
              </td>

              <td class="text-left text-grey">

                <div class="d-flex align-items-center justify-content-between w-100">

                  <button class="history-chip" [ngClass]="{
                      'active-history': row.has_history,
                      'inactive-history': !row.has_history
                    }" title="View History" (click)="viewHistory(row)">

                    <i class="fa fa-eye"></i>

                    <span class="chip-text">
                      {{ row.has_history ? 'Has Updates' : 'View History' }}
                    </span>

                  </button>

                </div>

              </td>

            </tr>

          </tbody>

        </ng-container>
<!-- 
      <ng-template #noResult>
        <tbody>
          <tr>
            <td colspan="5" class="text-center no-result-cell">
              <nz-empty nzNotFoundContent="No result Found"></nz-empty>
            </td>
          </tr>
        </tbody>
      </ng-template> -->

      </nz-table>

    </div>
  </div>
</div>

<nz-drawer [nzVisible]="isHistoryModalVisible" [nzTitle]="drawerTitleTpl" nzPlacement="right" [nzWidth]="760"
  [nzClosable]="true" [nzBodyStyle]="{ padding: '0px', background: '#f8fafc' }" (nzOnClose)="closeHistoryModal()">

  <!-- Header Template -->
  <ng-template #drawerTitleTpl>
    <div class="drawer-header">
      <div class="title">Invoice History</div>
      <div class="sub-title">
        {{ selectedHistoryRow?.transaction_no }}
      </div>
    </div>
  </ng-template>

  <div class="history-wrapper">

    <!-- Summary Card -->
    <div class="summary-card">
      <div class="summary-item">
        <label>Transaction No</label>
        <span>{{ selectedHistoryRow?.transaction_no }}</span>
      </div>

      <div class="summary-item">
        <label>Type</label>
        <span>{{ selectedHistoryRow?.transaction_type }}</span>
      </div>

      <div class="summary-item">
        <label>Total Events</label>
        <span>{{ historyArr.length }}</span>
      </div>
    </div>

    <!-- Loader -->
    <div *ngIf="historyLoading" class="drawer-loader">
      <nz-spin nzSimple></nz-spin>
      <div class="loader-text">Loading history...</div>
    </div>
    
    <!-- Empty -->
    <div *ngIf="!historyLoading && historyArr.length === 0" class="empty-wrap">
      No history found
    </div>

    <!-- Timeline -->
    <div *ngIf="!historyLoading && historyArr.length > 0" class="timeline">

      <div class="timeline-item" *ngFor="let h of historyArr; let i = index">

        <div class="timeline-line" *ngIf="i !== historyArr.length - 1"></div>

        <div class="timeline-dot" [ngClass]="{
            'dot-create': h.action_type == 'INSERT',
            'dot-update': h.action_type == 'UPDATE',
            'dot-delete': h.action_type == 'DELETE'
          }">
        </div>

        <div class="timeline-card">

          <div class="card-top">

            <div>
              <div class="date">
                {{ h.created_at | date:'dd MMM yyyy, hh:mm a' }}
              </div>

              <div class="user">
                {{ h.user_name }}
              </div>
            </div>

            <div class="right-actions">

              <span class="status create" *ngIf="h.action_type == 'INSERT'">
                Created
              </span>

              <span class="status update" *ngIf="h.action_type == 'UPDATE'">
                Updated
              </span>

              <span class="status delete" *ngIf="h.action_type == 'DELETE'">
                Deleted
              </span>

            </div>

          </div>

          <div class="card-bottom" *ngIf="h.action_type == 'UPDATE'">
            <button class="diff-btn" (click)="viewDiff(h)">
              View Changes
            </button>
          </div>

        </div>

      </div>

    </div>

  </div>

</nz-drawer>

<nz-drawer [nzVisible]="isDiffModalVisible" [nzTitle]="diffTitleTpl" nzPlacement="right" [nzWidth]="1000"
  [nzClosable]="true" [nzBodyStyle]="{ padding: '0px', background: '#f8fafc' }" (nzOnClose)="closeDiffModal()">

  <!-- Drawer Header -->
  <ng-template #diffTitleTpl>
    <div class="drawer-header">
      <div class="title">Changes Made</div>
      <div class="sub-title">
        {{ selectedDiffRow?.transaction_no }}
      </div>
    </div>
  </ng-template>

  <div class="diff-wrapper">

    <!-- Loader -->
    <div *ngIf="diffLoading" class="drawer-loader">
      <nz-spin nzSimple></nz-spin>
      <div class="loader-text">Loading changes...</div>
    </div>

    <ng-container *ngIf="!diffLoading">


      <!-- Empty -->
      <div *ngIf="!diffLoading && !hasDiffChanges(selectedDiff)" class="empty-wrap">
        No changes detected
      </div>

      <ng-container *ngIf="!diffLoading && hasDiffChanges(selectedDiff)">

        <!-- General -->
        <div class="diff-section" *ngIf="selectedDiff?.top_level_changes?.length > 0">
          <div class="section-title">General</div>

          <div class="diff-card" *ngFor="let c of selectedDiff.top_level_changes">
            <div class="field-name">{{ c.field }}</div>

            <div class="compare-grid">
              <div class="old-box">
                <label>Old</label>
                <div>{{ c.old_value || '-' }}</div>
              </div>

              <div class="new-box">
                <label>New</label>
                <div>{{ c.new_value || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Total Fare -->
        <div class="diff-section" *ngIf="selectedDiff?.total_fare_changes?.length > 0">
          <div class="section-title">Total Fare</div>

          <div class="diff-card" *ngFor="let c of selectedDiff.total_fare_changes">
            <div class="field-name">{{ c.field }}</div>

            <div class="compare-grid">
              <div class="old-box">
                <label>Old</label>
                <div>{{ c.old_value || '-' }}</div>
              </div>

              <div class="new-box">
                <label>New</label>
                <div>{{ c.new_value || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Travellers -->
        <div class="diff-section" *ngIf="selectedDiff?.traveller_changes?.length > 0">
          <div class="section-title">Travellers</div>

          <div class="diff-card" *ngFor="let c of selectedDiff.traveller_changes">
            <div class="field-name">
              {{ c.traveller }} - {{ c.field }}
            </div>

            <small class="text-muted">
              Ticket No: {{ c.ticket_no }}
            </small>

            <div class="compare-grid mt-2">
              <div class="old-box">
                <label>Old</label>
                <div>{{ c.old_value || '-' }}</div>
              </div>

              <div class="new-box">
                <label>New</label>
                <div>{{ c.new_value || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Sectors -->
        <div class="diff-section" *ngIf="selectedDiff?.sector_changes?.length > 0">
          <div class="section-title">Sectors</div>

          <div class="diff-card" *ngFor="let c of selectedDiff.sector_changes">
            <div class="field-name">
              {{ c.sector }} - {{ c.field }}
            </div>

            <div class="compare-grid">
              <div class="old-box">
                <label>Old</label>
                <div>{{ c.old_value || '-' }}</div>
              </div>

              <div class="new-box">
                <label>New</label>
                <div>{{ c.new_value || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>

    </ng-container>

  </div>

</nz-drawer>
